/*
 * @Descripttion: 
 * @Author: esther
 * @Date: 2023-04-23 16:03:03
 */
/**
 * 设置tableHeight
 * @param 默认返回除导航栏高度，可以再传入当前页面要排除的其他元素高度
 */
const getTableHeight = (_this,otherHeight = 0) => {
  _this.$nextTick(function () {
    let herdearHeight = document.querySelector('.commonTopbar').offsetHeight
    let navHeight = document.querySelector('#header').offsetHeight + 10
    let clientHeight = document.documentElement.clientHeight;
    let tableHeight = clientHeight - herdearHeight - navHeight;
    tableHeight = `${tableHeight - otherHeight - 20}px`
    _this.tableHeight = tableHeight
  });
}
/*
 * @Descripttion: 数字格式化千分位
 * @Author: repick
 * @Date: 2024-11-11 15:06:54
 */
export const formatNumberToThousandth = (num = 0) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * @Author: lixiang
 * @description: 页码展开
 * @param {*} _this
 */
const paginationToggle =(_this) =>{
  _this.paginationLayout = 'total, sizes, prev, pager, next,jumper'
  _this.isPaginationUp = true
}

export default {
  getTableHeight,
  paginationToggle
};